// 是否pionex环境，如果不存在环境标识，则成立。也用于标记非 BU 环境
import { tradingConfig } from "./config";

/**
 * @deprecated Use
 * {@link PlatformInfo.PIONEX_LIKE}
 *  instead.
 */
export function isPionex() {
  return tradingConfig.platformInfo.PIONEX_LIKE;
}